import { InputHTMLAttributes, FC } from "react";
import { FormImputLabel, Input, Group } from "./Form-input.style";

type FormInputProps = {
  label: string;
} & InputHTMLAttributes<HTMLInputElement>;

const FormInput: FC<FormInputProps> = ({ label, ...otherProps }) => {
  return (
    <Group>
      <Input {...otherProps} />
      {label && (
        <FormImputLabel
          shrink={Boolean(
            otherProps.value &&
              typeof otherProps.value === "string" &&
              otherProps.value.length
          )}
        >
          {label}
        </FormImputLabel>
      )}
    </Group>
  );
};

export default FormInput;
